import { useAppSelector } from '@frontend/common';
import { UserGroupClient } from '@frontend/group/api';
import { navigationStore } from '@frontend/terminal/shared';
import { UserClient } from '@frontend/user/api';
import { IUser } from '@frontend/user/types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ContactListProps } from './contact-list.component';

interface ViewProps {
    users: IUser[];
    isLoading: boolean;
}

const useUsersList = (props: ContactListProps): ViewProps => {
    const navigationState = useAppSelector(useSelector, navigationStore);
    const [users, setUsers] = useState<IUser[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (props.userInterface.data?.receiverGroup && navigationState.iot) {
            UserGroupClient.fetchUserGroup(navigationState.iot.account_id, props.userInterface.data.receiverGroup).then((group) => {
                UserGroupClient.fetchUserGroupMembers({ group_id: group.id }).then((members) => {
                    UserClient.resolveUsers(members.results.map((m) => m.entity_id)).then((users) => {
                        setUsers(users.results);
                        setIsLoading(false);
                    });
                });
            });
        } else {
            UserClient.fetchUsers().then((res) => {
                setUsers(res.results);
                setIsLoading(false);
            });
        }
    }, []);

    return {
        users,
        isLoading
    };
};

export default useUsersList;
